import React, { useRef, useState } from "react";
import SigninWrapper from "../wrapper/SigninWrapper";
import Button from "../button/Button";
import { otpVeri } from "../../API/PasswordRecovery/PasswordRecovery";
import ButtonLoader from "../button/ButtonLoader";

export default function OtpVerification({
  onNext,
  setStepValues,
  stepsValues,
}) {
  const [otp, setOtp] = useState(Array(6).fill(""));
  const inputRefs = useRef([]);
  const [loading, setLoading] = useState(false);

  const handleKeyDown = (e) => {
    if (
      !/^[0-9]{1}$/.test(e.key) &&
      e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "Tab" &&
      !e.metaKey
    ) {
      e.preventDefault();
      console.log(otp);
    }

    if (e.key === "Delete" || e.key === "Backspace") {
      const index = inputRefs.current.indexOf(e.target);
      if (index > 0) {
        setOtp((prevOtp) => [
          ...prevOtp.slice(0, index - 1),
          "",
          ...prevOtp.slice(index),
        ]);
        inputRefs.current[index - 1].focus();
      }
    }
  };

  const handleInput = (e) => {
    const { target } = e;
    const index = inputRefs.current.indexOf(target);
    if (target.value) {
      setOtp((prevOtp) => [
        ...prevOtp.slice(0, index),
        target.value,
        ...prevOtp.slice(index + 1),
      ]);
      if (index < otp.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleFocus = (e) => {
    e.target.select();
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const text = e.clipboardData.getData("text");
    if (!new RegExp(`^[0-9]{${otp.length}}$`).test(text)) {
      return;
    }
    const digits = text.split("");
    setOtp(digits);
  };

  const isOtpComplete = otp.every((digit) => digit === "");
  console.log("isOtpComplete", isOtpComplete);

  const handleSubmit = (e) => {
    setLoading(true);
    otpVeri({
      email: stepsValues.email,
      otp: otp.join(""),
    }).then((res) => {
      //
      setStepValues({
        email: stepsValues.email,
        code: otp.join(""),
      });
      setLoading(true);
      //
      onNext();
    });
  };

  // console.log(otp.length === 6);

  return (
    <SigninWrapper headingText={"Otp Verification"}>
      <form className="flex gap-2 justify-center items-center">
        {otp.map((digit, index) => (
          <input
            key={index}
            type="text"
            maxLength={1}
            value={digit}
            onChange={handleInput}
            onKeyDown={handleKeyDown}
            onFocus={handleFocus}
            onPaste={handlePaste}
            ref={(el) => (inputRefs.current[index] = el)}
            className="shadow-xs flex w-[64px] items-center justify-center rounded-lg border border-stroke bg-white p-2 text-center text-2xl font-medium text-gray-5 outline-none sm:text-4xl "
          />
        ))}
      </form>
      {loading ? (
        <div className="w-full flex justify-center items-center">
          <ButtonLoader />
        </div>
      ) : (
        <div className="flex justify-center items-center">
          <Button
            onClick={handleSubmit}
            disabled={isOtpComplete}
            text={"Otp verify"}
            customClass={"w-[60%] mx-auto"}
          />
        </div>
      )}
    </SigninWrapper>
  );
}
